import { useEffect, useState } from "react";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { useFormikContext } from "formik";
import apiRequestHelper from "../../../../utils/apiRequestHelper";
import { toast } from "react-toastify";

interface Tag {
  id: number;
  name: string;
}

const TagSection = () => {
  const { values, setFieldValue } = useFormikContext<any>();
  const [availableTags, setAvailableTags] = useState<Tag[]>([]);
  const [selectedTags, setSelectedTags] = useState<number[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTags();
  }, []);

  useEffect(() => {
    // Initialize selected tags from form values if editing
    if (values.tagIds && Array.isArray(values.tagIds)) {
      setSelectedTags(values.tagIds);
    }
  }, [values.tagIds]);

  const fetchTags = async () => {
    try {
      setLoading(true);
      const response = await apiRequestHelper.get("/tags");
      setAvailableTags(response.data.data.tags);
    } catch (error: any) {
      toast.error(
        error.response?.data?.messages?.[0]?.message || "Failed to load tags"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleTagToggle = (tagId: number) => {
    const newSelectedTags = selectedTags.includes(tagId)
      ? selectedTags.filter((id) => id !== tagId)
      : [...selectedTags, tagId];

    setSelectedTags(newSelectedTags);
    setFieldValue("tagIds", newSelectedTags);
  };

  return (
    <Row>
      <Col>
        <FormGroup>
          <Label>
            Tags <span className="text-muted">(Optional)</span>
          </Label>
          {loading ? (
            <p className="text-muted">Loading tags...</p>
          ) : availableTags.length === 0 ? (
            <p className="text-muted">
              No tags available. Create tags first from the Tags menu.
            </p>
          ) : (
            <div className="d-flex flex-wrap gap-2">
              {availableTags.map((tag) => (
                <div
                  key={tag.id}
                  onClick={() => handleTagToggle(tag.id)}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "20px",
                    border: "2px solid",
                    borderColor: selectedTags.includes(tag.id)
                      ? "#00AC46"
                      : "#ccc",
                    backgroundColor: selectedTags.includes(tag.id)
                      ? "#00AC46"
                      : "transparent",
                    color: selectedTags.includes(tag.id) ? "#fff" : "#28797c",
                    cursor: "pointer",
                    transition: "all 0.2s",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                >
                  {tag.name}
                </div>
              ))}
            </div>
          )}
          {selectedTags.length > 0 && (
            <div className="mt-2">
              <small className="text-success">
                {selectedTags.length} tag(s) selected
              </small>
            </div>
          )}
        </FormGroup>
      </Col>
    </Row>
  );
};

export default TagSection;

